import type {
  SumsubAccessTokenResult,
  SumsubFlowAccessTokenRequest,
  SumsubSettingsResponse,
} from "@repo/shared/types";
import { get, post, postWithToken } from "./_client";

const SETTINGS_BASE = "/internal/sumsub/settings";

export function getSettings(): Promise<SumsubSettingsResponse> {
  return get<SumsubSettingsResponse>(SETTINGS_BASE);
}

// Flow-instance-scoped access token. The server generates `externalUserId`
// and persists the mapping needed for webhook routing — callers pass one only
// to refresh a running session (`refreshExternalUserId`). URL shape differs by
// surface:
//   internal: /internal/flow-instances/{instanceId}/sumsub-verification/access-token
//   public:   /public/flow/sumsub-verification/access-token (instanceId is in the session token)
export async function generateSumsubFlowAccessToken(
  url: string,
  body: SumsubFlowAccessTokenRequest,
  authToken?: string,
): Promise<SumsubAccessTokenResult> {
  if (authToken) {
    return postWithToken<SumsubAccessTokenResult>(
      url,
      authToken,
      body satisfies SumsubFlowAccessTokenRequest,
    );
  }
  return post<SumsubAccessTokenResult>(url, body satisfies SumsubFlowAccessTokenRequest);
}
